import { Timeline } from 'vis-timeline/standalone/esm'

export function useVisTimeline(container, items, groups, options = {}) {
  options = {
    editable: false,
    groupOrder: 'content',
    moveable: false,
    orientation: 'top',
    selectable: false,
    showCurrentTime: true,
    showMajorLabels: false,
    stack: true,
    zoomable: false,
    zoomMax: 1000 * 60 * 60 * 24,
    zoomMin: 1000 * 60 * 60 * 24,
    format: {
      minorLabels: {
        hour: 'HH:mm',
      },
      majorLabels: {
        hour: 'ddd D MMM YYYY',
      },
    },
    locale: 'en',
    tooltip: {
      followMouse: true,
      overflowMethod: 'cap',
    },
    margin: {
      item: {
        horizontal: 5,
        vertical: 5,
      },
    },
    timeAxis: {
      scale: 'hour',
      step: 1,
    },
    xss: {
      disabled: true,
    },
    ...options,
  }
  return new Timeline(container, items, groups, options)
}
